__webpack_require__.p = "https://gfiber.com/micro-apps/_next/";